const ITEMS = [
  "Change management",
  "Strategic foresight",
  "Community energy",
  "Just transition",
  "Climate action",
  "Systems thinking",
  "Alchemy",
];

export const Marquee = () => (
  <div className="bg-ink border-y border-gold/20 py-5 overflow-hidden" data-testid="marquee-strip">
    <div className="animate-marquee flex whitespace-nowrap w-max">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center">
          {ITEMS.map((item, i) => (
            <span key={`${dup}-${i}`} className="flex items-center">
              <span className="font-display italic text-gold/90 text-lg md:text-xl px-6">{item}</span>
              <span className="text-cream/30 text-xs">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
